import React from 'react';
import PropTypes from 'prop-types';
class Tab extends React.PureComponent {
    render() {
        return React.createElement("div", null, this.props.children);
    }
}
Tab.propTypes = {
    /** Specifies an unique id for a tab button. Use it to differentiate between tabs */
    id: PropTypes.string.isRequired,
    /** Renders any content inside of a tab. */
    children: PropTypes.node.isRequired,
    /** Defines the title of the tab. */
    name: PropTypes.node.isRequired,
    /** Specifies whether the tab button is disabled. */
    disabled: PropTypes.bool,
};
export default Tab;
//# sourceMappingURL=Tab.js.map